import { useTranslation } from 'react-i18next';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Icon, EyeOff } from '../../ui/Icon';
import type { Activity } from '../../../types';
import { endTimeOf } from '../../../utils/activityOrder';

/**
 * ADR-0039: a stop of the travellers' own (their booking, a meal, or the origin
 * that copies one), as agency staff see it. The server sent only its slot —
 * hour and duration — so the day still adds up; there is nothing to open,
 * edit or drag. It stays in the sortable list so the stops around it move as usual.
 */
export function MaskedStopCard({ activity }: { activity: Activity }) {
  const { t } = useTranslation();
  const { setNodeRef, transform, transition } = useSortable({ id: activity.id, disabled: true });
  const end = endTimeOf(activity);

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className="flex items-center gap-3 rounded-xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/60 px-3.5 py-3"
    >
      <Icon as={EyeOff} size={14} className="shrink-0 text-slate-400" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{t('itinerary.maskedStop.title')}</p>
        <p className="text-2xs text-slate-400 dark:text-slate-500">{t('itinerary.maskedStop.hint')}</p>
      </div>
      {activity.startTime && (
        <span className="font-mono text-[11px] font-semibold text-slate-400 tabular-nums shrink-0">
          {activity.startTime}{end ? ` – ${end}` : ''}
        </span>
      )}
    </div>
  );
}
